<div class="title">
  <button
    class="close-icon"
    mat-icon-button
    (click)="onCloseClick()"
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div class="content">
  <div class="header">{{ header | uppercase }}</div>
  <div class="items">
    <div class="main-item">
      <div class="image-wrapper">
        <img
          class="image"
          [src]="parentItem.primaryImageUrl"
          imgErrLog
        />
      </div>
    </div>
    <div class="compatible-items">
      <app-visionboard-workspace-template-lane
        #templateLane
        class="lane"
        [lane]="lane"
        [showTitle]="true"
        [showBorder]="true"
        [disableChecks]="true"
      ></app-visionboard-workspace-template-lane>
      <button
        class="placeholder"
        (click)="onPlaceholderClick()"
        *ngIf="!hasItems()"
        merriNoFocusLink
      >
        <span class="add-icon-text">
          <mat-icon
            class="add-icon"
            svgIcon="plus"
          ></mat-icon>
          <span class="add-text">Add a {{ childItemTitle | lowercase }}</span>
        </span>
        <span class="add-note">Cushions are strongly recommended for this chair</span>
      </button>
    </div>
  </div>
</div>
